import { Component, Input } from '@angular/core';
import { DateComponent } from '../date/date.component';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'ma-execution-date',
  templateUrl: './execution-date.component.html',
  styleUrls: ['./execution-date.component.less'],
  imports: [DateComponent, TranslateDirective],
})
export class ExecutionDateComponent {
  @Input()
  date: Date | null;
  @Input() public isSelected: string;
}
